import { getAuth } from 'firebase/auth';

export interface HistoryItem {
  downloadURL: string;
  size?: number;
  storagePath?: string;
  uploadedAt?: Date;
}

export interface AdminGetDownloads_Data {
  key: string;
  displayName: string;
  currentVersion: string;
  downloadUrl: string;
  size: number;
  storagePath: string;
  uploadedAt: Date;
  webIcon: string;
  history?: HistoryItem[];
}

export async function adminDownloadsGet(): Promise<AdminGetDownloads_Data[]> {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Not authenticated');
  }
  const token = await user.getIdToken();
  const res = await fetch('/api/admin/getAdminDownloads', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  if (!res.ok) {
    throw new Error('failed to fetch downloads');
  }
  // format output
  let rawData: any[] = await res.json();
  return rawData.map((item) => ({
    key: item.key || '',
    displayName: item.displayName || 'unknown software item',
    currentVersion: item.currentVersion || 'unknown version',
    downloadUrl: item.downloadUrl || '',
    size: item.size || 0,
    storagePath: item.storagePath || '',
    uploadedAt: item.uploadedAt ? new Date(item.uploadedAt) : new Date(0),
    webIcon: item.webIcon,
    history: item.history ? item.history.map((h: any) => ({
      downloadURL: h.downloadURL || '',
      size: h.size || 0,
      storagePath: h.storagePath || '',
      uploadedAt: h.uploadedAt ? new Date(h.uploadedAt) : new Date(0),
    })) : []
  }));
}

